import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { logError } from "@/lib/logger";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) { setError("Sessão inválida"); return; }

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        // Clear the hash so refresh doesn't re-trigger
        window.history.replaceState(null, "", "/minha-conta");
        await refresh();
        toast.success(`Bem-vindo, ${data.user.name?.split(" ")[0] || ""}!`);
        nav(data.user.role === "admin" ? "/admin" : "/minha-conta", { replace: true });
      } catch (e) {
        logError("[auth-callback] google session failed:", e);
        setError(e.response?.data?.detail || "Falha na autenticação Google");
      }
    })();
    // processed ref guarantees single-run; refresh/nav come from stable hooks
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen grid place-items-center bg-neutral-50">
      <div className="text-center">
        {!error ? (
          <>
            <div className="w-12 h-12 mx-auto rounded-full border-2 border-neutral-300 border-t-neutral-900 animate-spin" />
            <div className="mt-6 font-heading font-black text-xl">Finalizando login…</div>
            <div className="mt-2 text-sm text-neutral-500">Você será redirecionado em instantes.</div>
          </>
        ) : (
          <>
            <div className="font-heading font-black text-2xl text-red-600">Erro</div>
            <div className="mt-2 text-sm text-neutral-600">{error}</div>
            <a href="/login" className="mt-6 inline-block underline font-semibold">Voltar ao login</a>
          </>
        )}
      </div>
    </div>
  );
}
